<template>
  <div v-if="path" class="row">
    <!-- fluidSelectRow -->
    <div class="col-4">
      <label
        v-tooltip="uniToolTipTranslation('S572', 'en-US')"
        class="label-unidato geometrySelectLabel"
      >
        {{ uniTranslation("S572") }}</label
      >
    </div>
    <div class="col-8">
      <el-select v-model="selectedGeometry" class="geometrySelect" placeholder="..." filterable>
        <el-option
          v-for="item in geometryList"
          :key="item.id"
          :label="item.descrizione"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import geometryService from "../../services/backend/geometryService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      geometryList: [],
      selectedGeometry: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    selectedGeometry: function(nv /*, ov*/) {
      if (nv != null && nv != undefined) {
        var idg = parseInt(nv);
        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".geometry.id",
          value: idg
        });
      }
    }
  },
  mounted: function() {
    var that = this;
    that.$nextTick(function() {
      geometryService.getGeometry().then(function(data) {
        data.forEach(element => {
          that.geometryList.push({
            descrizione: element.descrizione,
            diametroEsterno: element.diametroEsterno,
            idModalita: element.idModalita,
            id: element.id,
            passoRanghi: element.passoRanghi,
            passoTubi: element.passoTubi
          });
        });
        that.selectedGeometry = jsonHelper.getProperty(that.projects, that.path + ".geometry.id");
      });
    });
  },
  methods: {}
};
</script>

<style lang="scss">
.geometrySelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.geometrySelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}

.geometrySelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
</style>
